import { useParams } from 'react-router-dom';
import { useQuery } from '@tanstack/react-query';
import api from '../../utils/api';
import { applyInspectionDue } from '../../utils/inspectionDueDate';

export default function PeriodReport() {
  const { id, term } = useParams();
  const { data: job, isLoading } = useQuery({
    queryKey: ['job', String(id)],
    queryFn: async () => (await api.get(`/jobs/${id}`)).data,
  });

  if (isLoading && !job) return <div className="p-8 text-sm text-gray-600">Loading report…</div>;
  if (!job) return <div className="p-8 text-sm text-gray-600">Report not found.</div>;

  const code = String(term || '').toUpperCase();
  const due = applyInspectionDue(job).due_date || 'date';
  const ss = String(job.ss_code || 'ss').trim();
  const building = job.building_name || job.building?.name || 'Building';
  const fileName = `ss ${ss.replace(/^ss\s+/i, '')}-report-${building}-${due}-${code}.html`;

  return (
    <div className="max-w-3xl mx-auto p-6">
      <div className="bg-card rounded-lg shadow p-6 space-y-3">
        <h1 className="text-xl font-semibold text-gray-900">
          {ss} report {code}
        </h1>
        <p className="text-sm text-gray-700">
          {building}
          {job.building_address || job.building?.address ? ` · ${job.building_address || job.building?.address}` : ''}
        </p>
        <p className="text-sm text-gray-700">Due {due}</p>
        <p className="text-sm text-gray-700">Status {job.status || '—'}</p>
        <p className="text-sm text-gray-700">
          Saved name <span className="font-medium">{fileName}</span>
        </p>
        <p className="text-xs text-gray-600">
          Intermediate reports keep the period on the end of the file name ({code}). The last document of the year uses
          the same rule with its own period.
        </p>
      </div>
    </div>
  );
}
